module.exports = __webpack_public_path__ + "img/mastercard.3fca489e.svg";